import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import SignaturePad from "signature_pad";
import { SignatureSource, SignatureType } from '../../../SecurePatientCommunication/models/chat.enum';
import moment from 'moment';
import { PatientEngagementService } from '../../services/patient-engagement.service';
@Component({
  selector: 'app-signature-capture',
  templateUrl: './signature-capture.component.html',
  styleUrl: './signature-capture.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class SignatureCaptureComponent {
  @Output() isSignatureApplyied = new EventEmitter<any>();
  @ViewChild("canvas", { static: true }) canvas!: ElementRef;

  signature:any = SignaturePad;
  isChecked: boolean = false;

  @Input()
  CopayValue: boolean | undefined; 
  @Input() zeroCopay: any;
   localToUtcFormat: string | undefined;
  @Input() selectedTransDetails: any;
  signatureList: any = [];
  base64Data: any;
  copayValue: any;
  elinkParams: any;
  signAndConsentGiven: boolean = false;
  @HostListener('window:resize')
  onResize() {
    this.ngAfterViewInit();
  }
  
  constructor( private _router: Router, private _peServie: PatientEngagementService,) {}

  ngOnInit(){
    //console.log(this.CopayValue,"CopayValue")
    this.signature = new SignaturePad(this.canvas.nativeElement,{
      minWidth: 0.8,
      maxWidth: 1.5,
      throttle: 16
    });
     this.localToUtcFormat = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
     this.elinkParams = JSON.parse(localStorage.getItem('paramsData') as string);
  }

    ngAfterViewInit() {
    this.initPad();
  }
  initPad() {
    const canvas = this.canvas.nativeElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const cssWidth  = window.innerWidth <= 320 ? 254 : (window.innerWidth <= 414 ? 302 : 500);
    const cssHeight = 240;
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = cssWidth * dpr;
    canvas.height = cssHeight * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    canvas.style.width = `${cssWidth}px`;
    canvas.style.height = `${cssHeight}px`;
    this.signature = new SignaturePad(canvas, { minWidth: 0.8, maxWidth: 1.0, throttle: 16 });
    this.signature.onEnd = () => {
  this.signature.onEnd = () => this.emitIfValid();
    };
    const dataUrl = canvas.toDataURL('image/png');
   this.base64Data = dataUrl.replace(/^data:image\/(png|jpeg);base64,/, '');
    const emit = () => this.signature.onEnd && this.signature.onEnd();
    canvas.onpointerup = emit;
    canvas.ontouchend  = emit as any;
    canvas.onmouseup   = emit;
  }

  signatureCheck(value: boolean) {
      if (value) {
        const base64Data = this.signature.toDataURL('image/png');
        this.isSignatureApplyied.emit(base64Data);
      } else {
        this.isSignatureApplyied.emit(value);
      }
  }

  clear() {
    this.signature.clear();
     this.emitIfValid(); 
  }
  
  cancel(){
    localStorage.removeItem('selectedTransDetails');
    this._router.navigate(['/revieworders']);
  }

  next(){
        if (event) {
           this.copayValue = this.selectedTransDetails?.amount
           const payloadForsetupSaleSig = {
           signatureImageBase64:  this.base64Data,
          signatureSource: SignatureSource.MyPrimeRx,
          signatureType: SignatureType.Payment,
          SignatureDtTm: this.localToUtcFormat
        };
          this.signatureList = [payloadForsetupSaleSig];
              const payload = {
              transID: this.selectedTransDetails?.transID,
              npiNo: this.elinkParams?.npi,
              Signatures: this.signatureList
              }
              this._peServie.addSignatureOnly(payload).subscribe(resp=>{
               localStorage.setItem("copayValue", this.selectedTransDetails?.amount);
              this._router.navigate(['/payment-confirm'], {
               state: {isNonZeroCopay: "true"}
                });
                });
        }
  }
  onAgreeChange(event: Event) {
    this.isChecked = (event.target as HTMLInputElement).checked;
   this.emitIfValid();
}

emitIfValid() {
  if (!this.signature?.isEmpty() && this.isChecked) {
    const dataUrl = this.signature.toDataURL('image/png');
    this.base64Data = dataUrl.replace(/^data:image\/(png|jpeg);base64,/, '');
    this.isSignatureApplyied.emit(dataUrl);
    this.signAndConsentGiven = true;
  } else {
    this.isSignatureApplyied.emit(null);
    this.signAndConsentGiven = false;
  }
}

}
